import { Link } from '@compat/router';
import { aboutEmail } from '@images';
import Picture from '../Picture';
import './SaleBanner.scss';

const SaleBanner = () => (
  <Link to='/catalog/rasprodazha' className='sale-banner'>
    <Picture
      icon={aboutEmail}
      width='510'
      height='385'
      className='sale-banner__img'
    />
    <div className='sale-banner__title'>Море скидок</div>
    <div className='sale-banner__sub-title'>
      Ловите скидки <br /> на странице распродажа
    </div>
    <div className='sale-banner__btn'>За скидками</div>
  </Link>
);

export default SaleBanner;
